import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted, ref, watch, onUnmounted } from 'vue';
import * as echarts from 'echarts';
export default {
  __name: 'base',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    const chartRef = ref(null);
    let chartInstance = null;
    onMounted(() => {
      if (chartRef.value) {
        // eslint-disable-next-line import/namespace
        chartInstance = echarts.init(chartRef.value);
        chartInstance.setOption(props.options);
        chartInstance.resize();
      }
    });
    watch(() => props.options, newOptions => {
      if (chartInstance) {
        chartInstance.setOption(newOptions);
      }
    }, {
      deep: true
    });
    onUnmounted(() => {
      if (chartInstance) {
        chartInstance.dispose();
        chartInstance = null;
      }
    });
    __expose({
      resize: () => {
        if (chartInstance) {
          chartInstance.resize();
        }
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "chartRef",
        ref: chartRef,
        style: {
          "width": "100%",
          "height": "100%",
          "background": "white"
        }
      }, null, 512);
    };
  }
};